import css from 'styled-jsx/css';
import { colors } from '../../config/styles';

const RelatedKeywordsStyles = css`
  .related-keywords {
    display: flex;
    background-color: ${colors.white.shade1};
    border-radius: var(--border-radius);

    .related-keywords-heading {
      width: 183px;
      height: 14px;
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      color: ${colors.black.shade10};
      margin: 8px 16px 8px 0;
      white-space: nowrap;
    }

    .related-keywords-scrollable-container {
      @mixin mobileToTablet {
        display: inline-flex;
        width: 100%;
        overflow: scroll;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 10+ */
      }
    }
    .related-keywords-scrollable-container::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    @mixin mobileToTablet {
      display: block;
      margin-top: 0;
      padding: 8px 0 16px 16px;
      height: 84px;
    }
    @mixin tabletToDesktop {
      align-items: center;
      margin-left: 10px;
      padding-left: 16px;
      height: 54px;
    }
  }
`;

export { RelatedKeywordsStyles };
